
export default function ShowEntries(props){
    const {totalCount, itemsCountPerPage, activePage} = props;
    let starting = totalCount === 0 ? 0 : (activePage - 1) * itemsCountPerPage + 1;
    let ending = itemsCountPerPage * activePage > totalCount ? totalCount : itemsCountPerPage * activePage;
    return(
        <div>Showing {starting} to {ending} of {totalCount} entries</div>
    )
}